module.exports = __webpack_public_path__ + "assets/img/s2.88936045.jpg";